// src/services/dashboard/BookManager.js
import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = `${config.url}/api/admin`;
const PAGE_SIZE = 15; // Default page size matching frontend

const BookManager = {

/**
 * Fetch paginated books using POST as per controller requirements
 * @param {Object} options - { page?: number, size?: number, userId?: number }
 */
async getAllBooks({ page = 0, size = PAGE_SIZE, userId = null } = {}) {
  try {
    const requestPayload = {
      page,
      size,
      userId,
    };

    const response = await axiosInstance.post(`/books/getAllBooks`, requestPayload);
    return response.data;
  } catch (err) {
    console.error("Error fetching books:", err.response?.data || err.message);
    throw err;
  }
},

async fetchAllBooks() {
  try {
    const response = await axiosInstance.get(`/books/all`);
    return response.data.responseData;
  } catch (error) {
    console.error("Error fetching all books:", error.response?.data || error.message);
    throw error;
  }
},

async getBookById(id, userId = null) {
  const response = await axiosInstance.post(`/books/get-book`, {
    id: id,
    userId: userId
  });
  return response.data;
},


async addBook(book, bookImages) {
  const formData = new FormData();
  formData.append("book", JSON.stringify(book));
  if (bookImages?.length > 0) {
    bookImages.forEach(img => formData.append("bookImages", img));
  }

  try {
    const response = await axiosInstance.post(`/books/create`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response.data;
  } catch (error) {
    // Extract backend error
    const message = error?.response?.data?.responseMessage || "Failed to add book.";
    throw new Error(message);
  }
},


  async updateBook(book, bookImages) {
    const formData = new FormData();

    // Send the book as the BookCreateUpdateDTO (excluding unnecessary fields for updates)
    formData.append("book", JSON.stringify(book));  // The book will follow the new DTO structure

    if (bookImages && bookImages.length > 0) {
      bookImages.forEach(img => formData.append("bookImages", img));
    }

    try {
      const response = await axiosInstance.put(`/books/update`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating the book:", error);
      throw error;  // You can also show a toast or handle the error here
    }
  },



  async deleteBook(id) {
    const response = await axiosInstance.delete(`books/${id}`);
    return response.data;
  },

  async getBooksByAuthor(authorId, userId) {
    const requestData = {
      authorId: authorId,
      userId: userId,
    };
    const response = await axiosInstance.post(`books/author/all`, requestData);
    return response.data.responseData;
  },

  async getBooksByCategory(categoryId, userId) {
    const requestData = {
      categoryId: categoryId,
      userId: userId,
    };

    const response = await axiosInstance.post(`books/category/all`, requestData);
    return response.data;
  },

  async getBookCount() {
    const response = await axiosInstance.get(`/books/count`);
    // response.data will be a number, e.g. 17
    return response.data;
  },


  async searchBooks(keyword, userId) {
    const response = await axiosInstance.post(`books/search`, {
      keyword: keyword,
      userId: userId
    });
    return response.data;
  },

};

export default BookManager;
